import React from 'react';
import PropTypes from 'prop-types';
import { IonListHeader, IonLabel } from '@ionic/react';

function CategoryItem({ item, ...rest }) {
  return (
    <IonListHeader id={item.id} className="menu-category" {...rest}>
      <IonLabel>
        <div>
          <b
            className={`menu-category__name menu-category-level-${item.level}`}
          >
            {item.level > 4 ? '- ' : ''}
            {item.name}
          </b>
          {item.path && <p className="menu-category__path">{item.path}</p>}
          {item.description && (
            <p className="menu-category__desc">{item.description}</p>
          )}
        </div>
      </IonLabel>
    </IonListHeader>
  );
}

CategoryItem.propTypes = {
  item: PropTypes.object,
};

export default CategoryItem;
